// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EBSy","top":"styles_top__2MyeA"};